import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-recap-credit',
    templateUrl: './recap-credit.component.html',
    styleUrls: ['./recap-credit.component.scss']
})
export class RecapCreditComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    constructor(public cityService: CityService, public adService: AdService, public commonService: CommonService) {
    }

    ngOnInit() {
    }

    edit(event, fields = '') {
        this.favorite = this.adService.cleanInput(this.favorite);

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }
}
